<style scoped lang="less">
.looking {
	background: #0d6efd;
	margin-left: 10px;

	span {
		font-size: 0.6rem;
		font-weight: 800;
		color: #fff;
	}
}

.smaall {
	background: #0acf97;
	margin-left: 10px;

	span {
		font-size: 0.6rem;
		font-weight: 800;
		color: #fff;
	}
}

.smaall:hover {
	background: #0adf9f;
}

.lookxj {
	background: #ff9528;
	margin-left: 10px;

	span {
		font-size: 0.6rem;
		font-weight: 800;
		color: #fff;
	}
}

.lookxj:hover {
	background: #f38d26;
}

.looking:hover {
	background: #0b67e6;
}

.choiostitle {
	display: flex;
	padding: 0.8rem 0.4rem;
	align-items: center;
	justify-content: space-between;
	background-color: #fff;
	margin-bottom: 1rem;
	border-left: 4px solid #ab26aa;

	.choiosvspde {
		/deep/ .el-button-group {
			width: 9rem;

			button:first-child {
				width: 7rem;
				height: 2rem;
				padding: 0 3px;
			}

			button:last-child {
				width: 1.6rem;
				height: 2rem;
				position: relative;
				padding: 0;
				top: 0px;
				left: 0px;
			}
		}
	}

	.choiostitleleft {
		padding: 0.5rem;
		font-size: 0.8rem;
		border-radius: 50%;
		color: #fff;
		background-color: #ab26aa;
		border: 1px solid;
		text-align: left;
		margin-left: 0.6rem;
		box-sizing: border-box;

		span {
			font-weight: 900;
			font-size: 1.2rem;
		}
	}

	.choiosvdate {
		width: 13rem;
		margin-right: 2%;

		/deep/ .el-input {
			width: 100%;
		}
	}

	.choiosipt {
		// width: 9rem;
		margin-right: 2%;

		/deep/ .el-input {
			width: 100%;
		}
	}

	.choiostitleright {
		display: flex;
		align-items: center;
		justify-content: flex-end;

		div {
			margin: 0 0.2rem;
		}

		.choiosipt {
			/deep/ .el-input--prefix .el-input__inner {
				height: 2rem;
				padding: 1rem 2rem;
			}

			/deep/ .el-input__prefix {
				top: -3px;
			}

			/deep/ .el-input__suffix {
				top: -3px;
			}
		}
	}
}

.orderstable {
	// margin-top: 1rem;
	padding: 1rem;
	width: 100%;
	background-color: #fff;
	border-top: 4px solid #ab26aa;
	border-radius: 2px;

	.oderlookds {
		background-color: #f41127;
	}

	.oderlookd {
		padding: 0.1rem;
		width: 4rem;
		background: rgb(78, 192, 204);
		color: rgb(255, 255, 255);
		margin: 0 auto;
		border-radius: 5px;
	}

	.tabslis {
		/deep/ & ::-webkit-scrollbar {
			width: 5px;
			height: 8px;
			background: linear-gradient(to right, #2e61bf, #60c363);
		}

		& ::-webkit-scrollbar {
			width: 10px;
			height: 5px;
			// background: red;
		}

		& ::-webkit-scrollbar-track {
			-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
			border-radius: 0;
			background: rgba(0, 0, 0, 0.1);
		}

		/deep/ .el-table {
			th,
			td {
				text-align: center;
			}

			td {
				button {
					color: #fff;
					border-radius: 5px;
					margin: 5px;
				}

				.looking {
					background: #0d6efd;
					// margin-left: 10px;

					span {
						font-size: 0.6rem;
						font-weight: 800;
					}
				}

				.looking:hover {
					background: #0b67e6;
				}

				.giveempower {
					background: #ff8300;

					span {
						font-size: 0.6rem;
					}
				}

				.giveempower:hover {
					background: #e17000;
				}

				.edit {
					background: #17a001;

					span {
						font-size: 0.6rem;
					}
				}

				.edit:hover {
					background: #1fcf00;
				}

				.delete {
					background: #ec0f25;

					span {
						font-size: 0.6rem;
					}
				}

				.delete:hover {
					background: #ff1128;
				}
			}
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}

		/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
			background: linear-gradient(to right, #018761, #39b170);
			// color: #FFF;
		}
	}

	.schooltitle {
		font-size: 1.2rem;
		color: #ab26aa;
		display: flex;
		align-items: center;
		border-bottom: 1px solid #ccc;
		padding-bottom: 1rem;
		position: relative;

		button {
			padding: 0.4rem;
			background: #fe8930;
			font-size: 0.6rem;
			border-radius: 3px;
			padding: 0.6rem 1.2rem;
			position: absolute;
			right: 1%;
			color: #fff;

			span {
				color: #fff;
				margin-right: 0.2rem;
				font-weight: 900;
			}
		}

		span.el-icon-s-management {
			display: block;
			padding: 0.4rem;
			border-radius: 50%;
			font-size: 1rem;
			margin-right: 0.4rem;
			box-sizing: border-box;
			background: #ab26aa;
			color: #fff;
		}
	}
}

.paginations {
	height: 3rem;
	line-height: 3rem;

	input {
		width: 3rem;
		height: 1.8rem;
		padding: 0 0 0 0.8rem;
		border: 1px solid #ccc;
	}
}

#sector {
	min-height: 90%;
}

.lookxqs {
	width: 100%;
	box-sizing: border-box;
	background: linear-gradient(to right, #0898ff, #0898ff);
	color: #fff;
	padding: 0 1rem;
	border-radius: 10px;
	margin-bottom: 1rem;

	.lookxqbottom {
		padding-left: 1rem;

		ul {
			width: 50% !important;
			li:first-child {
				font-size: 0.8rem !important;
				font-weight: 600;
			}
			li {
				width: 40% !important;
			}

			margin-right: 6rem;
		}
	}

	.lookxqtop,
	.lookxqbottom {
		padding: 0.6rem 0;
		display: flex;
		box-sizing: border-box;
		align-items: center;
		flex-wrap: wrap;
		justify-items: flex-start;
		border-bottom: 1px solid #83cbff;

		ul {
			margin: 0.2rem 0;
			width: 100%;

			li:last-child {
				span {
					display: none;
				}
			}

			box-sizing: border-box;
			align-items: center;

			li {
				font-size: 0.8rem;
				width: 30%;
				text-align: center;
				display: inline-block;
			}

			li:first-child {
				font-size: 1rem;
				font-weight: 600;
				margin-right: 1rem;
				width: 15%;
			}

			// margin-right: 6rem;
		}
	}
}

.lookxqtop,
.lookxqbottom {
	ul::-webkit-scrollbar  {
		width: 2px;
		// height: 10px; // 高度写不写，都不影响，因为会根据内容的长度自动计算
	}

	ul::-webkit-scrollbar-thumb {
		background: #ccc; // 滑块颜色
		border-radius: 5px; // 滑块圆角
	}
	div::-webkit-scrollbar  {
		display: none;
	}
	div::-webkit-scrollbar-thumb {
		display: flex;
	}
}

.scllocw {
	overflow-y: scroll;
}

.ablictyly {
	height: 53vh;
	border: 1px solid transparent;
	border-radius: 10px;
	background-color: #fff;

	padding-bottom: 1rem;
	position: relative;

	.abilitysgn {
		height: 90%;
		padding-left: 1rem;
	}

	.ablictylybottom {
		padding: 0 1rem;
		height: 76%;

		/deep/ .el-table__header {
			th {
				text-align: center;
			}
		}

		/deep/ .el-table__row {
			td {
				text-align: center;
			}
		}
	}

	.totles {
		position: absolute;
		bottom: 0;
		left: 0;
		background-color: #fff;
		box-sizing: border-box;
		box-shadow: 10px 10px 10px 10px rgba(0, 0, 0, 0.1);
		padding: 10px 0;
	}

	.ablictylycenter {
		width: 100%;
		display: flex;
		align-items: center;
		justify-items: flex-start;
		padding: 0.4rem 0.4rem;
		height: 3rem;
		line-height: 3rem;

		.actives {
			border: 1px solid;
			height: 2rem;
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 0 1rem;
			border-radius: 10rem;
			color: #fff;
			background: #4a8dc9;
		}

		p {
			cursor: pointer;
			margin-right: 1rem;
			color: #333;
			font-size: 0.8rem;
		}

		/deep/ .el-select {
			width: 70%;
		}

		/deep/ .el-input__inner {
			height: 30px;
		}

		/deep/ .el-input__icon {
			line-height: 30px;
		}

		/deep/ .el-button {
			padding: 8px 20px;
			margin-left: 1rem;
			color: #fff;
			background-color: #2ebf91;
			font-size: 1rem;
		}
	}

	.ablictylytop {
		display: flex;
		align-items: center;
		justify-items: flex-start;
		background-color: #ffa319;
		color: #fff;
		padding: 0.2rem 0.6rem;
		border-top-left-radius: 10px;
		border-top-right-radius: 10px;

		img {
			border: 1px solid;
			padding: 0.2rem;
			border-radius: 0.4rem;
			background-color: rgba(255, 255, 255, 0.4);
		}

		p {
			margin-left: 0.4rem;
			font-size: 1rem;
			font-weight: 600;
			letter-spacing: 1px;
		}
	}

	&::-webkit-scrollbar-thumb {
		width: 5px;
		background: #ccc; // 滑块颜色
		border-radius: 5px; // 滑块圆角
	}
}

.totles {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: 1rem;
	font-size: 1rem;
	color: #333;

	p {
		margin-right: 1rem;
	}
}

.backtavle {
	width: 4rem;
	height: 4rem;
	border-radius: 50%;
	border: 1px solid;
	background: #0a4a87;
	position: fixed;
	bottom: 6%;
	text-align: center;
	line-height: 4rem;
	right: 1%;
	cursor: pointer;
	z-index: 999;
}

/deep/ .tablestitle {
	color: #333;

	.cell {
		font-weight: 600 !important;
	}

	// font-size: 1rem;
}
</style>
<template>
	<div>
		<titles v-if="looingz == 0" titlename="我的实训" titlecontent="这里可以看到我的实训一些信息" :mbx="paths"></titles>
		<div class="choios" v-if="looingz == 0">
			<div class="choiostitle">
				<button class="choiostitleleft "><span class="el-icon-wallet"></span></button>
				<div class="choiostitleright col-xs-8 col-sm-8 col-md-8 col-lg-8">
					<div class="choiosipt col-xs-4 col-sm-4 col-md-4 col-lg-4">
						<el-input @blur="changetrainlist()" placeholder="搜索" prefix-icon="el-icon-search" v-model="search"></el-input>
					</div>
					<div class="choiosvdate choiosipt"><el-date-picker @change="changetrvd()" v-model="vdate" type="date" placeholder="选择开始日期"></el-date-picker></div>
					<div class="choiosvspde choiosipt"><el-date-picker @change="changetrvds()" v-model="venddate" type="date" placeholder="选择结束日期"></el-date-picker></div>
				</div>
			</div>

			<div class="orderstable">
				<p class="schooltitle">
					<!-- <span class="el-icon-s-management"></span> -->
					<span>我的实训记录</span>
				</p>
				<div class="paginations">
					每页显示
					<input type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="tabsnun" @change="changenumber()" />
					行
				</div>
				<div class="tabslis">
					<template>
						<el-table :data="tableData" header-row-class-name="tablestitle" border style="width: 100%">
							<el-table-column fixed prop="TDT_TaskName" :resizable="false" label="任务名称"></el-table-column>
							<el-table-column prop="TDT_ProjectName" width="180" :resizable="false" label="项目名称">
								<template slot-scope="scope">
									<p style="text-align: left;width: 100%;" :title="scope.row.TDT_ProjectName">{{ scope.row.TDT_ProjectName }}</p>
								</template>
							</el-table-column>
							<el-table-column prop="TDT_StartTime" :resizable="false" width="160" label="项目创建时间"></el-table-column>
							<el-table-column prop="TDT_EndTime" :resizable="false" width="160" label="结束时间"></el-table-column>
							<el-table-column prop="ui_realName" :resizable="false" width="100" label="参赛成员"></el-table-column>
							<el-table-column prop="cla_name" :resizable="false" width="180" label="班级"></el-table-column>
							<el-table-column prop="pro_name" :resizable="false" label="专业"></el-table-column>
							<el-table-column prop="TDT_Score" :resizable="false" width="80" label="得分"></el-table-column>
							<el-table-column prop="LengthOfTimeSeconds" width="100" :resizable="false" label="累计用时(实训时长分钟)"></el-table-column>

							<el-table-column fixed="right" label="操作" :resizable="false" width="100">
								<template slot-scope="scope">
									<div class="userusec d-sm-none d-md-block" style="display: flex;align-items: center;">
										<el-button size="small" :class="'looking'" @click="tableTraiDetail($event, scope.row.TDT_TaskGuid)">查看详情</el-button>
									</div>
									<div class="userusec d-sm-block d-md-none">
										<el-dropdown trigger="click">
											<p class="el-dropdown-link">···</p>
											<el-dropdown-menu slot="dropdown">
												<el-tooltip class="item" effect="dark" content="详情" placement="bottom-start">
													<el-button size="small" :class="'looking'" @click="tableTraiDetail($event, scope.row.TDT_TaskGuid)">
														<span class="el-icon-s-order"></span>
														<!-- 详情 -->
													</el-button>
												</el-tooltip>
											</el-dropdown-menu>
										</el-dropdown>
									</div>
								</template>
							</el-table-column>
						</el-table>
					</template>
				</div>

				<div class="tabsnum">
					<p>
						显示
						<span>1</span>
						到
						<span>{{ tabsnun }}</span>
						,共
						<span>{{ allnum }}</span>
						条记录
					</p>
					<div class="elpagian" v-if="tableData.length > 0">
						<el-pagination @current-change="handleCurrentChange" background layout="prev, pager, next" :page-size="tabsnum" :total="allnum"></el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import {
	GetMyTrainDataList,
	getTraiDetailByTOPIDList,
	getTrainSTAByGUID,
	GetMyTrainDataListApi,
	getTraiDetailByTOPIDListApi,
	getTrainSTAByGUIDApi
} from '@/request/api/userapi/studenthome.js';
import AppOptions from '@/config/AppOptions.vue';
export default {
	components: {},
	data() {
		return {
			TrainingRooms: {},
			// 详情扣分项
			xqoptions: [],
			xqvalue: 0,
			// 查看详情
			looingz: 0,
			tackname: '',
			// 弹窗
			tabsnun: 10,
			Optiondata2: [],
			// 搜索
			search: '',
			// 时间选择
			vdate: '',
			venddate: '',
			// 标题
			paths: [
				{
					path: '/usercenter/myrealtest',
					name: '我的实训'
				}
			],
			tableData: [],
			allnum: 10,
			pageindex: 1,
			abilitysgnlist: [],
			objectName: '',
			abilitysgnobj1: {},
			abilitysgnobj2: {},
			// 分数
			abilityjgalist: [],
			GtsxTrainingList: [],
			// 总计
			totles: 0,
			totsles: 0,
			// 实训能力评估
			scores: 0,
			notes: '',
			chart1: {},
			abilitysgnobjs: {},
			option: {
				tooltip: {
					trigger: 'axis'
				},
				radar: {
					radius: '65%',
					name: {
						textStyle: {
							fontSize: 14,
							color: '#333'
							// fontWeight: 900
						}
					},
					startAngle: 90,
					splitNumber: 5,
					splitArea: {
						show: true,
						areaStyle: {
							color: ['rgba(157,200,241,0.1)', 'rgba(157,200,241,0.3)', 'rgba(157,200,241,0.1)', 'rgba(157,200,241,0.3)']
						}
					},
					splitLine: {
						lineStyle: {
							color: '#ccc'
						}
					},
					axisLine: {
						lineStyle: {
							width: 1,
							color: '#ccc'
						}
					},
					// indicator: this.ldData
					// 标题
					indicator: []
				},
				series: {
					show: true,
					top: '1%',
					left: '1%',
					width: '100%',
					type: 'radar',
					itemStyle: {
						color: '#9DC8F1'
					},
					lineStyle: {
						color: '#9DC8F1'
					},
					areaStyle: {
						color: '#9DC8F1',
						opacity: 0.8
					},
					tooltip: {
						trigger: 'item'
					},
					data: [
						{
							value: [], //雷达图数据
							name: '熟练程度'
						}
					]
				}
			}
		};
	},
	mounted() {
		this.gettrindapi();
	},
	components: {
		titles
	},
	computed: {
		tabsnum() {
			return Number(this.tabsnun);
		}
	},
	created() {
		AppOptions.appEmpty = false;
	},
	updated() {},
	methods: {
		changetrvd() {
			let date = new Date(this.vdate);
			let y = date.getFullYear();
			let m = date.getMonth() + 1;
			m = m < 10 ? '0' + m : m;
			let d = date.getDate();
			d = d < 10 ? '0' + d : d;
			const time = y + '-' + m + '-' + d;
			// console.log(time);
			var traisnobjs = {
				index: this.pageindex,
				size: this.tabsnun,
				ui_guid: localStorage.getItem('uiguid'),
				taskName: '',
				startTime: time,
				endTime: '',
				TDT_ProjectName: ''
			};
			this.gettrindapi(traisnobjs);
		},
		changetrvds() {
			var date = new Date(this.venddate);
			var y = date.getFullYear();
			var m = date.getMonth() + 1;
			m = m < 10 ? '0' + m : m;
			var d = date.getDate();
			d = d < 10 ? '0' + d : d;
			var times = y + '-' + m + '-' + d;
			var traisnobjs = {
				index: this.pageindex,
				size: this.tabsnun,
				ui_guid: localStorage.getItem('uiguid'),
				taskName: '',
				startTime: '',
				endTime: times,
				TDT_ProjectName: ''
			};

			this.gettrindapi(traisnobjs);
		},

		backtavle() {
			this.looingz = 0;
		},

		lookchange(i) {
			console.log(i);
			this.xqvalue = i;
			this.getxqtop(i);
		},

		lookingstain() {
			console.log(this.xqvalue);
		},

		// 变化选框切换
		changgetainl(i) {
			console.log(i);
			this.getxqtop(i);
		},

		indexMethod(index) {
			return (index += 1);
		},

		// 搜索更改列表
		changetrainlist() {
			// console.log("搜索")
			var reg = /^[\da-z]+$/i;
			let searchse = '';
			let searchseas = '';
			reg.test(this.search) == true ? (searchse = this.search) : (searchseas = this.search);
			var traisnobj = {
				index: this.pageindex,
				size: this.tabsnun,
				ui_guid: localStorage.getItem('uiguid'),
				taskName: searchse,
				startTime: '',
				endTime: '',
				TDT_ProjectName: searchseas
			};
			this.gettrindapi(traisnobj);
		},

		chars() {
			getTrainSTAByGUIDApi(this.tackname).then(res => {
				// console.log(res)
				var chart1 = this.$echarts.init(document.getElementById('sector'));
				this.chart1 = chart1;
				this.notes = res.data.data.notes;
				let nums = res.data.data.score;
				this.scores = Math.floor(nums * 2) / 2;
				// console.log(this.scores)

				let mytrainseries = [];
				res.data.data.list.forEach(item => {
					mytrainseries.push(item.totalScore);
				});
				let maxs = Math.max(...mytrainseries);

				let projelist = [];
				let totalscore = [];
				res.data.data.list.forEach(item => {
					let projeobj = {};
					projeobj.name = item.projectName;
					projeobj.max = maxs;
					projelist.push(projeobj);
					totalscore.push(item.resultScore);
				});
				if (this.option.series.data[0]) {
					this.option.series.data[0].value = totalscore;
				}
				this.option.radar.indicator = projelist;
				this.chart1.setOption(this.option);
			});
			window.onresize = () => {
				this.chart1.resize();
			};
		},
		handleClose(done) {
			done();
			// this.$confirm('确认关闭？')
			// 	.then(_ => {
			// 		done();
			// 	})
			// 	.catch(_ => {});
		},
		// 查看详情
		tableTraiDetail(e, id) {
			// this.looingz = 1;
			this.$router.push('/usercenter/myrealtestchart?id='+id);
			this.tackname = id;
		},
		// 查看详情
		getxqtop(i = 0) {
			getTraiDetailByTOPIDListApi(this.tackname).then(res => {
				// console.log(res, "查看详情")
				this.abilitysgnlist = res.data.data.length > 4 ? res.data.data.slice(0, 4) : res.data.data;
				this.objectName = res.data.data[0].TDT_TaskName;
				this.abilitysgnobj1 = res.data.data[0];
				if (res.data.data[0]) {
					this.GtsxTrainingList = res.data.data[0].GtsxTrainingList;
				}
				// this.abilitysgnobj2 = res.data.data[0].TrainingEquipment;
				this.abilityjgalist = this.abilitysgnlist;
				let xqoptionslist = [];
				this.abilitysgnlist.forEach((item, index) => {
					let abiltyobj = {};
					abiltyobj.value = item.TDT_ProjectName;
					abiltyobj.lable = index;
					xqoptionslist.push(abiltyobj);
				});
				this.xqoptions = xqoptionslist;

				let totlelist = [];
				let totleslist = [];
				this.abilityjgalist.forEach((item, index) => {
					// console.log(item.projecScore,item.totalgrade)
					let tsscov = parseInt(item.TDT_TotalScore) - parseInt(item.TDT_Score);
					totleslist.push(tsscov);
					item.tsScore = tsscov;
					totlelist.push(item.TDT_Score);
				});
				// console.log(totleslist,totlelist)

				let sum = 0;
				this.totles = totlelist.reduce(function(pre, curr) {
					sum = pre + curr;
					return sum;
				});

				this.totsles = totleslist.reduce(function(pre, curr) {
					sum = pre + curr;
					return sum;
				});
			});
		},

		// 改变表格
		handleCurrentChange(val) {
			// console.log(`当前页: ${val}`);
			this.pageindex = val;
			this.gettrindapi();
		},

		// 改变表单
		changenumber() {
			this.gettrindapi();
		},
		gettrindapi(trnobj = null) {
			let trainobj = {
				index: this.pageindex,
				size: this.tabsnun,
				ui_guid: localStorage.getItem('uiguid'),
				taskName: '',
				startTime: '',
				endTime: '',
				projectName: ''
			};

			trainobj = trnobj == null ? trainobj : trnobj;
			GetMyTrainDataListApi(trainobj).then(res => {
				console.log(res.data.data, '我的实训记录');
				this.allnum = res.data.data.totalCount;
				this.tableData = res.data.data.list;
				this.tableData.forEach(item => {
					if (item.as_isArrival == false) {
						item.as_isArrival = '否';
					} else {
						item.as_isArrival = '是';
					}
				});
			});
		}
	}
};
</script>
